import { Avatar, DifficultyIndicators } from 'src/components';
import { Coach as CoachModel } from 'src/models/Coach';

import {
  Card,
  Layout,
  Label,
  Image,
  Header,
  Overline,
  TitleRow,
  Title,
  PlaylistMenuSlot,
  Underline,
  Coach,
  CoachAvatars,
  Separator,
  Difficulty,
  Duration,
} from './styles/main';

import LikeButton from './LikeButton';

const MAX_VISIBLE_COACH_AVATARS = 3;

const formatCoachNames = (coaches: CoachModel[]): string => {
  if (coaches.length <= 2) return coaches.map(c => c.name).join(', ');
  return `${coaches[0]!.name}, ${coaches[1]!.name} i ${coaches.length - 2} więcej`;
};

export const SessionCardActual: React.FC<{
  contentType: 'session' | 'challenge' | 'challengeSession';
  link: string;
  title: string;
  underline: string;
  image?: string;
  overlineLabel: string;
  type?: string;
  coaches: CoachModel[];
  difficulty: number;
  duration?: number;
  mode: 'horizontal' | 'vertical';
  isLiked: boolean;
  onToggleLike?: () => void;
  showPublicLike?: boolean;
  isPublicLiked?: boolean;
  publicLikesCount?: number;
  onTogglePublicLike?: () => void;
  publicLikePending?: boolean;
  playlistMenu?: React.ReactNode;
}> = ({
  contentType,
  link,
  title,
  underline,
  image = '',
  overlineLabel,
  coaches,
  difficulty,
  duration,
  mode,
  isLiked,
  onToggleLike,
  showPublicLike,
  isPublicLiked = false,
  publicLikesCount = 0,
  onTogglePublicLike,
  publicLikePending,
  playlistMenu,
}) => (
  <Card to={link}>
    <Layout>
      <Image mode={mode}>
        <img src={image} alt=""/>
        <LikeButton
          liked={isLiked}
          onToggle={onToggleLike}
          showPublicLike={showPublicLike}
          publicLiked={isPublicLiked}
          publicLikesCount={publicLikesCount}
          onTogglePublicLike={onTogglePublicLike}
          publicLikePending={publicLikePending}
        />
      </Image>
      <Header>
        <Overline highlight={contentType === 'challenge'}>
          {overlineLabel}
        </Overline>
        <TitleRow>
          <Title>{title}</Title>
          {playlistMenu ? (
            <PlaylistMenuSlot
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              {playlistMenu}
            </PlaylistMenuSlot>
          ) : null}
        </TitleRow>
        <Underline>{underline}</Underline>
      </Header>
      {coaches.length > 0 && (
        <Coach>
          <CoachAvatars>
            {coaches.slice(0, MAX_VISIBLE_COACH_AVATARS).map(c => (
              <Avatar key={c.id} size="small" imageSrc={c.thumbnail ?? ''} />
            ))}
          </CoachAvatars>
          <Label>{formatCoachNames(coaches)}</Label>
        </Coach>
      )}
      <Separator />
      <Difficulty>
        <Label>Poziom</Label>
        <DifficultyIndicators difficulty={difficulty}/>
      </Difficulty>
      <Duration duration={duration} />
    </Layout>
  </Card>
);
